<template>
  <div class="hello text-left">
    <b-col md="4" class="mx-auto">
      <div class="text-center">
        <img src="../assets/mcIcon.png" style="width:100px" class="mx-auto">
      </div>
      <b-card title="Login">
        <b-form @submit="onSubmit">
          <b-form-group
            id="input-group-empresa"
            label="Empresa"
            label-for="input-empresa"
            description="Código da Empresa"
          >
            <b-form-input
              id="input-empresa"
              v-model="form.empresa"
              required
              placeholder="Código da Empresa"
            ></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-usuario" label="Usuário" label-for="input-usuario">
            <b-form-input
              id="input-usuario"
              v-model="form.username"
              required
              placeholder="Usuário"
            ></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-senha" label="Senha" label-for="input-senha">
              <b-form-input
                id="input-senha"
                v-model="form.password"
                type="password"
                required
                placeholder="Senha"
              ></b-form-input>
          </b-form-group>
          <b-button type="submit" block variant="primary">Entrar</b-button>
        </b-form>
      </b-card>
    </b-col>
  </div>
</template>

<script>
import LoginService from '../services/LoginService'
import form from '../mixins/form'
export default {
  name: 'login',
  mixins: [form],

  data () {
    return {
      msg: 'Login',
      form: {
        empresa: '',
        username: '',
        password: ''
      }
    }
  },
  mounted () {
    this.$emit('is-login')
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()

      let obj = {
        empresa: this.form.empresa,
        username: this.form.username,
        password: this.form.password
      }

      LoginService.create(obj).then((result) => {
        console.log(result)
        localStorage.usuarioMC = JSON.stringify(result)
        this.$router.push({name: 'Home'})
      }).catch((err) => {
        this.handleResponseError(err)
        console.log(err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue